<template>
  <div class="budget">
    <div class="container">
      <div class='cont'>
        <div class='info-box'>
          <div class='row row-pay'><span>工程款（元）</span></div>
          <div class='row pay'>{{pay}}</div>
          <div :class="[isPay ? 'sign is-pay' : 'sign']">{{payText}}</div>
        </div>
      </div>
      <div class='detail'>
        <div v-for="fileInfo in fileInfos" :key="fileInfo.name" class="cn-block">
          <div class="busstype" style="text-align: left;">
            <div class="download-msg">
              <a :href="fileInfo.value[0].url">
                <van-icon name="balance-list-o" size="0.7rem" style="vertical-align: middle; margin-right: 0.2rem;" />
              点击查看{{ fileInfo.name }}</a>
            </div>
          </div>
        </div>
        <div class='detail-item'>-工程款详情</div>
        <div class='detail-span'>
          <span>工单号</span><span style='float: right; color: #777;'>{{orderNo}}</span>
        </div>
        <!-- <div class='detail-span'>
          <span>户名</span><span style='float: right; color: #777;'>{{userName}}</span>
        </div> -->
        <div class='detail-item'>-备注</div>
        <div class='detail-span'>
          <span>如已缴费，请勿重复缴费</span>
        </div>
      </div>
    </div>
    <div :class="[isPay ? 'button-disabled go-business button-primary' : 'go-business button-primary']" @click="getPay(isPay)">立即缴费</div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Notify, Grid, GridItem, Icon, Toast, Image as VanImage } from 'vant'
import { getWxJsBeanReq, getWxPayPrepayid, getBusDetailReq, updateWxPayStatusReq } from '@/api/manage'
import wx from 'weixin-jsapi'

Vue.use(Notify)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(VanImage)
Vue.use(Icon)
Vue.use(Toast)

export default {
  data () {
    return {
      linkedId: '',
      modelId: '',
      pay: '',
      orderNo: '',
      userName: '',
      isPay: false,
      payText: '',
      fileInfos: []
    }
  },
  components: {
  },
  created () {
    // 隐藏父路由底部logo
    this.$parent.footer(true)
    // 获取初始数据
    this.getInit()
    // 获取微信数据
    this.getWxApi()
  },
  methods: {
    getPay (isPay) {
      if (isPay) {

      } else {
        var that = this
        wx.ready(() => {
          wx.checkJsApi({
            jsApiList: ['chooseWXPay'],
            success: function (res) {
            },
            fail: function (res) {
              console.log('fail')
              console.log(res)
            }
          })
          const params = {
            token: that.$cookies.get('token'),
            openId: that.$cookies.get('openid'),
            linkedId: that.linkedId,
            type: 1,
            totalFee: that.pay,
            rule: '*',
            description: ''
          }
          // 获取预支付Id
          getWxPayPrepayid(params).then(response => {
            const res = response.data
            const orderNo = res.data.out_trade_no
            console.log(res)
            if (res.code === 200) {
              wx.chooseWXPay({
                timestamp: res.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: res.data.nonceStr, // 支付签名随机串，不长于 32 位
                package: res.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                signType: res.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                paySign: res.data.paySign, // 支付签名
                success: function (res) { // 支付成功后的回调函数
                  that.isPay = true
                  that.payText = '已缴费'
                  setTimeout(() => {
                    const paramsStatus = {
                      orderNo: orderNo
                    }
                    // 更新支付状态
                    updateWxPayStatusReq(paramsStatus).then(response => {
                      const res = response.data
                      if (res.code === 200) {
                        const paramsDetail = {
                          token: that.$cookies.get('token'),
                          openId: that.$cookies.get('openid'),
                          linkedId: that.linkedId
                        }
                        getBusDetailReq(paramsDetail).then(response => {
                          const res = response.data
                          if (res.code === 200) {
                            const localPage = res.data.localPage
                            that.$router.push({
                              path: localPage,
                              query: {
                                token: that.$cookies.get('token'),
                                linkedId: that.linkedId
                              }
                            })
                          }
                        })
                          .catch((res) => {
                            Notify({ type: 'danger', message: '获取业务信息失败' })
                          })
                      }
                    })
                      .catch((res) => {
                        Notify({ type: 'danger', message: '更新支付状态失败' })
                      })
                  }, 3000)
                },
                cancel: function (res) {
                  console.log('取消支付')
                },
                fail: function (res) {
                  Notify({ type: 'danger', message: '支付失败' })
                }
              })
            }
          })
            .catch((res) => {
              Notify({ type: 'danger', message: '获取微信支付配置失败' })
            })
        })
        wx.error(err => {
          console.log(err)
          Toast.fail('加载微信支付失败')
        })
      }
    },
    getInit () {
      var that = this
      const query = that.$route.query
      that.linkedId = query.linkedId

      const params = {
        token: that.$cookies.get('token'),
        openId: that.$cookies.get('openid'),
        linkedId: that.linkedId
      }
      // 获取业务详情
      getBusDetailReq(params).then(response => {
        const res = response.data
        if (res.code === 200) {
          // 修改父路由头部文字
          that.$parent.changeBusstypeText(res.data.serviceName, '')
          that.pay = res.data.payMoney
          that.orderNo = res.data.linkedId
          that.modelId = res.data.modelId
          if (res.data.paystatus === '3') {
            that.isPay = false
            that.payText = '未缴费'
          } else {
            that.isPay = true
            that.payText = '已缴费'
          }

          if (res.data.backendFormData) {
            var backendForm = JSON.parse(res.data.backendFormData)
            for (let i = 0; i < backendForm.length; i++) {
              const estimate = JSON.parse(backendForm[i].value)
              backendForm[i].value = estimate
            }
            this.fileInfos = backendForm
          }
        }
      })
        .catch((res) => {
          Notify({ type: 'danger', message: '获取业务信息失败' })
        })
    },
    getWxApi () {
      var that = this
      var token = that.$cookies.get('token')
      const params = {
        token: token,
        url: window.location.href
      }
      // 获取微信配置
      getWxJsBeanReq(params).then(response => {
        const res = response.data
        if (res.code === 200) {
          wx.config({
            debug: true, // 这里一般在测试阶段先用ture，等打包给后台的时候就改回false
            appId: res.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表
          })
        }
      })
        .catch((res) => {
          Notify({ type: 'danger', message: '获取微信配置失败' })
        })
    }
  }
}
</script>
<style lang="less" scoped>
  .go-business {
    margin-left: 25px;
    width: calc(100% - 50px);
    display: inline-block;
    margin-top: 0px;
    text-align: center;
  }
  .button-primary {
    height: 48px;
    line-height: 48px;
    background-color: #008ACB;
    font-size: 16px;
    color: #fff;
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
  }
  .button-disabled {
    background-color: #88C0F9;
  }
  .cont {
      position: relative;
      padding: 20px 15px 0;
  }
  .info-box {
      position: relative;
      margin-top: -60px;
      margin-left: 15px;
      margin-right: 15px;
      padding: 10px 25px 35px;
      border-radius: 5px;
      box-shadow: 0px 0px 8px #999;
      background-color: #fff;
  }
  .info-box .row {
      display: flex;
      margin-top: 20px;
  }
  .info-box .row-pay span {
      width: 100%;
      text-align: left;
      font-size: 15px;
  }
  .info-box .pay {
      font-size: 30px;
      color: red;
      justify-content: center;
  }
  .info-box .sign {
      position: absolute;
      right: 30px;
      top: 30px;
      width: 60px;
      height: 60px;
      border: 2px dotted #999;
      border-radius: 50%;
      text-align: center;
      line-height: 60px;
      color: #999;
      font-size: 15px;
      transform: rotate(-30deg);
  }
  .info-box .is-pay {
    color: red;
    border-color: red;
  }
  .detail {
      margin: 20px 25px 80px;
      color: #333;
  }
  .detail-item {
    font-size: 16px;
    font-weight: bold;
    margin-top: 25px;
  }
  .detail-span {
    font-size: 15px;
    padding: 15px 0 10px 0;
    border-bottom: 1px solid #e6e6e6;
  }
  .cn-block .busstype {
    background-color: #ffffff;
    padding: 15px 10px;
    text-align: center;
    margin: 20px 0;
    color: #727272;
    font-size: 16px;
    -webkit-box-shadow: #999 0px 0px 5px;
    -moz-box-shadow: #999 0px 0px 5px;
    box-shadow: #999 0px 0px 5px;
    line-height: 25px;
    border-radius: 4px;
    position: relative;
    margin-bottom: 30px;
  }
  .cn-block .busstype:not(:last-child)::after {
    position: absolute;
    bottom: -9px;
    left: 49%;
    content: '';
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #ffffff;
    filter: drop-shadow(1px 3px 1px rgba(0, 0, 0, .2));
  }
  .cn-block .busstype:last-child::after {
    background-color: #ffffff;
    padding: 15px 10px;
    text-align: center;
    margin: 20px 30px;
    color: #727272;
    font-size: 16px;
    -webkit-box-shadow: #999 0px 0px 5px;
    -moz-box-shadow: #999 0px 0px 5px;
    box-shadow: #999 0px 0px 5px;
    line-height: 25px;
    border-radius: 4px;
    position: relative;
    margin-bottom: 30px;
  }
  .cn-block .busstype .download-msg a {
    width: calc(100% - 40px);
    color: #1EB1E7;
    display: inline-block;
  }
</style>
